import apiClient from './client';

export interface Webhook {
  id: number;
  url: string;
  events: string[];
  secret?: string;
  is_active: boolean;
  created_at: string;
  updated_at: string;
}

export interface WebhookEvent {
  id: number;
  webhook_id: number;
  event_type: string;
  payload: any;
  status: 'pending' | 'success' | 'failed';
  response_code?: number;
  response_body?: string;
  created_at: string;
}

export const webhooksApi = {
  getAll: async (): Promise<Webhook[]> => {
    const response = await apiClient.get<{ success: boolean; data: Webhook[] }>('/webhooks');
    return response.data.data;
  },
  getById: async (id: number): Promise<Webhook> => {
    const response = await apiClient.get<{ success: boolean; data: Webhook }>(`/webhooks/${id}`);
    return response.data.data;
  },
  create: async (webhook: Partial<Webhook>): Promise<Webhook> => {
    const response = await apiClient.post<{ success: boolean; data: Webhook }>('/webhooks', webhook);
    return response.data.data;
  },
  update: async (id: number, webhook: Partial<Webhook>): Promise<Webhook> => {
    const response = await apiClient.patch<{ success: boolean; data: Webhook }>(`/webhooks/${id}`, webhook);
    return response.data.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/webhooks/${id}`);
  },
  test: async (id: number): Promise<void> => {
    await apiClient.post(`/webhooks/${id}/test`);
  },
  getEvents: async (webhookId: number): Promise<WebhookEvent[]> => {
    const response = await apiClient.get<{ success: boolean; data: WebhookEvent[] }>(`/webhooks/${webhookId}/events`);
    return response.data.data;
  },
};
